module.exports = __webpack_public_path__ + "static/media/fwzc_2.df02b9fe.jpg";